import * as React from 'react';

import {SelectLeadStatus} from 'shells/select-lead-status/select-lead-status';

import type {Lead as LeadFragment} from 'nutshell-graphql-types';

type Props = {
    lead: LeadFragment;
    shouldGrow?: boolean;
};

export function LeadStatusButton(props: Props) {
    return (
        <SelectLeadStatus
            classNamePrefix='lead-status'
            leadId={props.lead.id}
            value={props.lead.status}
            onChange={() => {}}
            // @ts-expect-error
            styles={{container: (base) => ({...base, flexGrow: props.shouldGrow ? 1 : undefined})}}
        />
    );
}
